import {
  IMPORTATION_REQUEST_MESSAGES,
  ImportationRequestMessages,
} from "./importation-request-messages";
import {
  IMPORTATIONS_FILTER_MESSAGES,
  ImportationsFiltersMessages,
} from "./importations-filter.messages";
import {
  IMPORTATIONS_TABLE_MESSAGES,
  ImportationsTableMessages,
} from "./importations-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ImportationsMessages = ImportationsFiltersMessages &
  ImportationsTableMessages &
  SidebarMessages &
  ImportationRequestMessages &
  ActionButtonMessages & {
    importationsPageTitle: string;
    importationsBreadCrumbTitle: string;
    markAllAsReadButton: string;
    importPopover: string;
  };

export const IMPORTATIONS_MESSAGES: ImportationsMessages = {
  importationsPageTitle: "Importações",
  importationsBreadCrumbTitle: "Importações",
  markAllAsReadButton: "Marcar todas como lidas",
  importPopover: "Ver Detalhes",

  ...SIDEBAR_MESSAGES,
  ...IMPORTATION_REQUEST_MESSAGES,
  ...IMPORTATIONS_FILTER_MESSAGES,
  ...IMPORTATIONS_TABLE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default IMPORTATIONS_MESSAGES;
